import React, { Fragment } from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  ReferenceField,
  BulkDeleteButton,
  SelectInput,
  BulkDeleteButtonProps,
  ListProps,
  ResourceContextProvider,
} from "react-admin";
import { GridinRow, GridLabel } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { statusList } from "pages/parents/conts";
import InternalNoteParentButton from "./components/InternalNoteParentButton";
import ListShowButton from "../../components/ListShowButton";
import ListEditButton from "../../components/ListEditButton";
import ListWrapper from "../../components/ListWrapper";
import ActionsMenu from "../../components/ActionsMenu";

const BulkActionButtons = (props: BulkDeleteButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
  </Fragment>
);

const ParentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput label="Status" source="Status" choices={statusList} alwaysOn />
  </Filter>
);

const ParentWithoutStudentList = (props: ListProps) => {
  const breadcrumb = [
    { link: "/parentsWithoutStudent", title: "Parents Without Student" },
  ];

  return (
    <>
      <ResourceContextProvider value="parents">
        <ListWrapper
          breadcrumb={breadcrumb}
          headerTitle="Parents Without Student"
          isNotHaveSchoolFilter
          basePath="/parents"
          exporter={false}
          hasCreate={true}
          filters={<ParentFilter />}
          filter={{
            IsHaveStudent: false,
            searchAllParentWithoutStudent: true, // custom for data provider
          }}
          sort={{ field: "CreatedAt", order: "DESC" }}
          bulkActionButtons={<BulkActionButtons />}
          {...props}
        >
          <Datagrid>
            <FunctionField
              label="Parent Info"
              render={() => (
                <SanitizedGrid container spacing={2}>
                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Id :
                    </Typography>
                    <TextField source="id" />
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Name :
                    </Typography>
                    <FunctionField
                      render={(record: any) =>
                        `${record.firstName} ${record.lastName}`
                      }
                    />
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Email :
                    </Typography>
                    <TextField source="user.email" emptyText="-" />
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Mobile :
                    </Typography>
                    <TextField source="mobile" />
                  </Grid>

                  <Grid item xs={12} style={GridinRow}>
                    <Typography variant="body2" style={GridLabel}>
                      Mbc Code :
                    </Typography>
                    <TextField source="user.mbcCustomerId" />
                  </Grid>
                </SanitizedGrid>
              )}
            />
            <FunctionField
              label="Student Info"
              render={(record: any) => (
                <>
                  {record.students && (
                    <SanitizedGrid container spacing={2}>
                      {record.students.length > 0 ? (
                        <>
                          {record.students.map(
                            (student: IStudent, index: number) => {
                              return (
                                <Fragment key={`student-key-${index}`}>
                                  <Grid item xs={12} style={GridinRow}>
                                    <Typography variant="body2">
                                      Name : {student.firstName}{" "}
                                      {student.lastName}
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} style={GridinRow}>
                                    <Typography
                                      variant="body2"
                                      style={GridLabel}
                                    >
                                      School :
                                    </Typography>
                                    <ReferenceField
                                      source={`students[${index}].schoolId`}
                                      reference="schools"
                                      emptyText="-"
                                      link={false}
                                    >
                                      <TextField source="name" />
                                    </ReferenceField>
                                  </Grid>

                                  <Grid item xs={4} style={GridinRow}>
                                    <Typography
                                      variant="body2"
                                      style={GridLabel}
                                    >
                                      Level :
                                    </Typography>
                                    <ReferenceField
                                      source={`students[${index}].levelId`}
                                      reference="levels"
                                      emptyText="-"
                                      link={false}
                                    >
                                      <TextField source="name" />
                                    </ReferenceField>
                                  </Grid>

                                  <Grid item xs={4} style={GridinRow}>
                                    <Typography
                                      variant="body2"
                                      style={GridLabel}
                                    >
                                      Class :
                                    </Typography>
                                    <ReferenceField
                                      source={`students[${index}].levelGroupId`}
                                      reference="levelGroups"
                                      emptyText="-"
                                      link={false}
                                    >
                                      <TextField source="name" />
                                    </ReferenceField>
                                  </Grid>

                                  <Grid item xs={12} style={GridinRow}>
                                    <Typography variant="body2">
                                      Status : {student.status}
                                    </Typography>
                                  </Grid>

                                  {record.students.length - 1 !== index && (
                                    <Grid item xs={8}>
                                      <Divider />
                                    </Grid>
                                  )}
                                </Fragment>
                              );
                            }
                          )}
                        </>
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <Typography variant="body2">-</Typography>
                          </Grid>
                        </>
                      )}
                    </SanitizedGrid>
                  )}
                </>
              )}
            />
            <CustomDateField source="createdAt" emptyText="-" isDateTime />
            <StatusField source="status" />
            <FunctionField
              label="Actions"
              render={(record: any) => (
                <ActionsMenu
                  render={[
                    <ListShowButton record={record} />,
                    <ListEditButton record={record} />,
                    <InternalNoteParentButton parentId={record.id} />,
                  ]}
                />
              )}
            />
          </Datagrid>
        </ListWrapper>
      </ResourceContextProvider>
    </>
  );
};

export default ParentWithoutStudentList;
